// utils function comparing `id` of two objects
// @ts-ignore
export const compareId = (a, b) => a.id === b.id
